export const getPasswordStrength = (password: string): string => {
  if (!password) return "";
  const hasLower = /[a-z]/.test(password);
  const hasUpper = /[A-Z]/.test(password);
  const hasNumber = /\d/.test(password);
  const hasSpecial = /[^a-zA-Z0-9]/.test(password);
  const conditionsMet = [hasLower, hasUpper, hasNumber, hasSpecial].filter(Boolean).length;

  if (password.length >= 8 && conditionsMet === 4) {return "Excellent"}
  if (password.length >= 6 && conditionsMet === 3) {return "Strong"}
  if (password.length >= 4 && conditionsMet >= 2) {return "Moderate"}
  if (password.length >= 2) {return "Weak"}
  return "Too short";
};